'use client';
import React, { useEffect, useState } from 'react';
import { AppPage } from '@/components/AppPage';
import { routes } from '@/routes';
import { useAppStore } from '@/stores/appStore';
import { History, Person, PiggyBank, ReceiptDollar, Reporting } from '@wolfejs/icons/IconMap';
import { useBuyerAccountManager } from '@wolfejs/ms-api-react/src/hooks/admin/buyers';
import type { Tile } from '@wolfejs/ms-ui/Landing';
import { LandingCard, NavigationTiles } from '@wolfejs/ms-ui/Landing';
import { FormatCurrency } from '@wolfejs/ui/Format';
import Link from 'next/link';

export const HomeContainer = ({ slug }: { slug: string }) => {
  const availableFunds = useAppStore(state => state.availableFunds);

  const [displayedFunds, setDisplayedFunds] = useState(0);
  

  useEffect(() => {
    // This check ensures that we only update displayedFunds when availableFunds is defined.
    // This fixes a mismatch between the markup generated between the
    // server side (which does not have access to the state) and the client side.
    if (availableFunds !== undefined) {
      setDisplayedFunds(availableFunds);
    }
  }, [availableFunds]); // Dependency on availableFunds means this effect runs whenever availableFunds changes

  const { data: buyerAccountManager } = useBuyerAccountManager();

  const tiles: Tile[] = [
    {
      url: `/${slug}${routes.orders}`,
      label: 'Order History',
      icon: <History className="h-20 w-20" />,
    },
    {
      url: `/${slug}${routes.products}`,
      label: 'Products',
      icon: <ReceiptDollar className="h-20 w-20" />,
    },
    {
      url: `/${slug}${routes.funds}`,
      label: 'Funds',
      icon: <PiggyBank className="h-20 w-20" />,
    },
    {
      url: `/${slug}${routes.userAccount}`,
      label: 'My Account',
      icon: <Person className="h-20 w-20" />,
    },
    {
      url: `/${slug}${routes.reports}`,
      label: 'Reporting',
      icon: <Reporting className="h-20 w-20" />,
    },
  ];

  return (
    <AppPage>
      <div className="flex h-full flex-col gap-4 @container">
        <div className="flex gap-8 @sm:flex-col @md:flex-row">
          {/* {buyerAccountManager ? (
            <LandingCard
              text={buyerAccountManager ? `${getFullName(buyerAccountManager)}` : null}
              badge="Your Account Manager"
              badgeColor={UIColors.default}
              footer={
                <>
                  {buyerAccountManager?.email && (
                    <Link href={`mailto:${buyerAccountManager?.email}`} className="text-primary underline">
                      {buyerAccountManager?.email}
                    </Link>
                  )}
                  {buyerAccountManager?.email && buyerAccountManager?.phoneNumber && (
                    <span className="text-base font-normal text-default-300">|</span>
                  )}
                  {buyerAccountManager?.phoneNumber && (
                    <Link href={`tel:${buyerAccountManager?.phoneNumber}`} className="text-primary underline">
                      {buyerAccountManager?.phoneNumber}
                    </Link>
                  )}
                </>
              }
            />
          ) : (
            <ApiError error={'Account Manager not found'} />
          )} */}
          <LandingCard
            badge="Available Funds"
            text={
              <FormatCurrency
                prefix="$"
                decimalScale={2}
                numberFormatBaseProps={{value: displayedFunds === 0 ? 0 : displayedFunds, displayType: 'text' }}
              />
            }
            footer={
              <Link
                href={`/${slug}${routes.funds}`}
                className="text-base font-bold text-primary no-underline hover:underline"
              >
                Manage Funds
              </Link>
            }
          />
        </div>
        <NavigationTiles tiles={tiles} />
      </div>
    </AppPage>
  );
};
